module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_location@2x-05b6e062eea5056786b991139cda3000.webp";